export default __webpack_public_path__ + "static/media/bulk-sample.0154d59d.png";